import { render, staticRenderFns } from "./habitChange.vue?vue&type=template&id=64faa8c4"
import script from "./habitChange.vue?vue&type=script&lang=js"
export * from "./habitChange.vue?vue&type=script&lang=js"
import style0 from "./habitChange.vue?vue&type=style&index=0&id=64faa8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports